/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={58} height={32} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient
        x1="-43.595%"
        y1="55.453%"
        x2="98.12%"
        y2="55.625%"
        id="prefix__a"
      >
        <stop stopColor="#B2D4FF" stopOpacity={0} offset="0%" />

        <stop stopColor="#ADD1FF" stopOpacity={0.05} offset="9%" />

        <stop stopColor="#9FC9FF" stopOpacity={0.18} offset="25%" />

        <stop stopColor="#89BDFF" stopOpacity={0.4} offset="48%" />

        <stop stopColor="#6BACFF" stopOpacity={0.69} offset="74%" />

        <stop stopColor="#4C9AFF" offset="100%" />
      </linearGradient>
    </defs>

    <path
      d="M404.846 78.358v-31.31h34.396c12.141 0 21.983 9.869 21.983 22.043h-18.768c-.03 5.127-4.183 9.267-9.295 9.267h-28.316zM372 35zm20.34 0z"
      fill="url(#prefix__a)"
      transform="translate(-404 -47)"
    />
  </svg>
);
